import {EventBus} from 'powtoon-commons/events'
import {PusherListener, PusherConfig} from 'powtoon-commons/pusher/PusherListener'
import webvarsConfigurationService from './webvarsConfigurationService'
import {LicenseUpdatedConverter, SessionExpiredConverter} from 'powtoon-commons/pusher/EventConverters'
import {createLogger} from 'logging'
import cookie from 'cookie'

const logger = createLogger('powtoon-producer-integration', 'event-service')

export const defaultEventBus: EventBus = new EventBus(logger)

const eventConverters = [
  LicenseUpdatedConverter,
  SessionExpiredConverter
]

export const initProducerEventBus = (): EventBus => {
  const config: PusherConfig = {
    pusherKey: webvarsConfigurationService.getWebVar('pusherKey'),
    userId: process.env.USER_ID || webvarsConfigurationService.getWebVar('userId'),
    sessionId: process.env.SESSION_ID || webvarsConfigurationService.getWebVar('sessionId'),
    csrfToken: process.env.CSRF_TOKEN || cookie.parse(document.cookie).csrftoken,
    apiHost: webvarsConfigurationService.getWebVar('apiHost'),
    cluster: webvarsConfigurationService.getWebVar('pusherRegion')
  }

  new PusherListener(config, eventConverters, defaultEventBus, logger)

  return defaultEventBus
}
